import styled from 'styled-components'

export const Error = styled.div`
  min-height: 60px;
  display: flex;
  align-items: flex-center;
  padding: 20px;
  border-radius: ${p => p.theme.borderRadius};
  line-height: ${p => p.theme.lineHeight};
  background: ${p => p.theme.redLightest};
  color: ${p => p.theme.red};
`
